module.exports = __webpack_public_path__ + "static/amaris_privacy-policy-8ec52d87f886c9e5084a9941190d1f5e.pdf";